<div class="capture-photo-container">
  <div class="header">
    <mat-icon class="back-arrow" (click)="goBack()">chevron_left</mat-icon>
    <span class="title">Capture Photo</span>
        <span class="page-indicator"><span style="font-weight: 1000;font-size: larger;">2</span>/3</span>

  </div>

  <div class="content-section">
    <div class="photo-capture-card">
      <div class="card-header">
        <p class="section-title">Photo Of Shop<span class="required-asterisk">*</span></p>
        <p class="instruction-text">
          It's mandatory to enable your device's location and allow access to camera before taking photo.
        </p>
      </div>

      <div class="photo-placeholder" (click)="openCamera()">
        <ng-container *ngIf="capturedImageUrl; else noPhoto">
          <img [src]="capturedImageUrl" alt="Captured Shop Photo" class="captured-image" />
          <mat-icon class="delete-icon" (click)="$event.stopPropagation(); clearCapturedImage()">delete_forever</mat-icon>
        </ng-container>
        <ng-template #noPhoto>
          <mat-icon class="camera-icon">photo_camera</mat-icon>
          <p class="click-text">Click to take photo</p>
        </ng-template>
        <input type="file" accept="image/*" capture="camera" (change)="onFileSelected($event)" #fileInput hidden />
      </div>
    </div>

    <div class="sample-image-card">
      <div class="card-header">
        <p class="section-title">View sample image below</p>
        <p class="instruction-text">
          Please upload shop photo covering the entire shop and take it during day time
        </p>
      </div>
      <div class="sample-image-wrapper">
        <img src="../../../assets/sample_shop_image.png" alt="Sample Shop Image" class="sample-image" />
      </div>
    </div>
  </div>

    <div *ngIf="isLocating" class="loading-spinner">
      <mat-spinner [diameter]="30"></mat-spinner>
      <p>Fetching Location...</p>
    </div>

  <div class="button-wrapper">
    <button
      mat-raised-button
      color="primary"
      class="save-next-button"
      [disabled]="!capturedImageUrl || !isOnline"
      (click)="saveAndNext()"
    >
      <span>Save & Next</span>
    </button>
  </div>
</div>